import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContactFormComponent } from '../../contact-form/contact-form.component';
import { AssignedUser } from '../../../../models/users/assignedUser';

@Component({
  selector: 'app-contact-dialog',
  templateUrl: './contact-dialog.component.html',
  standalone: false,
})
export class ContactDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<ContactDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {},
  ) {}

  close_click() {
    this.dialogRef.close();
  }
}
